<template>
  <div class="panel mt-20">
    <el-table :data="staffs" stripe style="width: 100%">
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column
        prop="phone_number"
        label="手机号"
        align="center"
      ></el-table-column>
      <!-- <el-table-column label="角色" align="center">
        <template slot-scope="scope">{{ showRoles(scope.row.roles) }}</template>
      </el-table-column> -->
      <!-- <el-table-column
        label="销售组"
        prop="group.name"
        align="center"
      ></el-table-column> -->
      <el-table-column label="状态" width="80">
        <template slot-scope="scope">
          <span
            :class="scope.row.status == 1 ? 'text-success' : 'text-danger'"
            >{{ scope.row.status == 1 ? '已启用' : '已禁用' }}</span
          >
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope" v-if="scope.row.status == 1">
          <el-popconfirm
            :title="'确认离职吗？'"
            @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
          >
            <el-button slot="reference" type="danger" plain size="mini"
              >离职</el-button
            >
          </el-popconfirm>
          <el-button
            type="primary"
            plain
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>
<script>
import {
  userList,
  groupList,
  createUser,
  updateUser,
  switchUserStatus,
} from '@/service/getData'
export default {
  props: {
    dealerID: 0,
  },
  data() {
    return {
      staffs: [],
    }
  },
  created() {
    this.requestMembers()
  },
  methods: {
    async requestMembers() {
      let data = { dealer_id: this.dealerID }
      let res = await userList(data)
      if (res.code == 0) {
        this.staffs = res.data.list
      }
    },
  },
}
</script>